import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/fonts.css';
import './styles/tokens.css';
import './index.css';
import { applyThemeChoice, readThemeChoice, THEME_EVENT, type ThemeChoice } from './utils/theme';

// Paket 08 Schritt 7 (EIN-10): dieselbe Wahl wie das Startskript in index.html; „System“ folgt dem Betriebssystem auch zur
// Laufzeit. Eine neue Wahl (Darstellung, Anmeldeseite) meldet zuerst die alte ab.
let stopTheme = applyThemeChoice(readThemeChoice());
window.addEventListener(THEME_EVENT, event => {
  stopTheme();
  stopTheme = applyThemeChoice((event as CustomEvent<ThemeChoice>).detail);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
